import React from "react";
import { Line } from "react-chartjs-2";
import ChartCard from "../ChartCard";
import { withLineChartStyles } from "../chartStyles";

const AverageStayDurationChart = ({ averageStayDurationChart }) => {
  return (
    <ChartCard chart={averageStayDurationChart}>
      <Line
        data={withLineChartStyles(averageStayDurationChart.data)}
        options={{
          responsive: true,
          maintainAspectRatio: false,
        }}
      />
    </ChartCard>
  );
};

export default AverageStayDurationChart;
